/* unplugin-vue-components disabled */import { render } from "./logisticsInfo.vue?vue&type=template&id=88980b7c&scoped=true"
import script from "./logisticsInfo.vue?vue&type=script&lang=js"
export * from "./logisticsInfo.vue?vue&type=script&lang=js"

import "./logisticsInfo.vue?vue&type=style&index=0&id=88980b7c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88980b7c"]])

export default __exports__